import { useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { doLogOut, getContaUrlCompleto } from "src/framework/store/LoginStore"
import { noPropagateDialog$ } from "src/store/global.store"

export function SignoutPage(){
  const location = useLocation()
  const history = useHistory()

  useEffect(()=>{
    const uri = window.location.origin.endsWith("/") ? window.location.origin : `${window.location.origin}/`
    noPropagateDialog$.next(true)
    doLogOut()
    getContaUrlCompleto(uri).then(contaUrl => {
      if (contaUrl) window.location.href = contaUrl
    })
  },[history, location, location.search])


  return (
    <span>Saindo...</span>
  )
}